import { useState } from 'preact/hooks';
import {
  SendMoneyBottomProvider,
  SendMoneyBottomSheetType,
} from './SendMoneyBottomProvider';
import NavigationUtils from '../../utils/navigation.utils';
import useTranslation from '../../localization/i18n.context';
import CardStatus from '../../constants/card.status';
import BottomSheetLayout from '../shared/BottomSheetLayout/BottomSheetLayout';

export default function SendMoneyBottomSheet({
  show = false,
  organizationCode,
  cardStatus = '',
  cardUid = '',
  sendMoneyToCompanyEnabled = false,
  onClose,
}) {
  const { t, getOrganization } = useTranslation();
  const [showBottomSheet, setShowBottomSheet] = useState(show);
  const [value, setValue] = useState(null);
  const data = SendMoneyBottomProvider(
    t,
    getOrganization(organizationCode),
    sendMoneyToCompanyEnabled,
  );

  function navigateToCardSettings() {
    NavigationUtils.navigate(NavigationUtils.Routes.CARD_SETTINGS, false, {
      organizationCode: organizationCode,
      source: NavigationUtils.Sources.WALLET,
    });
  }

  const onCloseClick = () => {
    setShowBottomSheet(false);
    onClose();
  };

  function navigateToSendMoneyP2P() {
    NavigationUtils.navigate(
      NavigationUtils.Routes.P2P_CONTACT_LIST.replace(':cardUid', cardUid),
      false,
      {
        organizationCode: organizationCode,
        source: NavigationUtils.Sources.WALLET,
        type: SendMoneyBottomSheetType.SEND_MONEY,
      },
    );
  }

  function navigateToSendMoneyToCompany() {
    NavigationUtils.navigate(NavigationUtils.Routes.ENTER_AMOUNT, false, {
      organizationCode: organizationCode,
      source: NavigationUtils.Sources.WALLET,
      type: SendMoneyBottomSheetType.SEND_MONEY_TO_COMPANY,
    });
  }

  function onConfirmBottomSheetButtonClick() {
    setShowBottomSheet(false);
    onClose();
    show = false;
    if (cardStatus === CardStatus.LOCKED) {
      navigateToCardSettings();
    } else {
      switch (value.type) {
        case SendMoneyBottomSheetType.SEND_MONEY: {
          navigateToSendMoneyP2P();
          break;
        }
        case SendMoneyBottomSheetType.SEND_MONEY_TO_COMPANY: {
          navigateToSendMoneyToCompany();
          break;
        }
      }
    }
  }

  return (
    <BottomSheetLayout
      showBottomSheet={showBottomSheet}
      title={data.title}
      items={data.items}
      titleStyle={data.titleStyle}
      selectedItem={value}
      onClose={() => onCloseClick()}
      onItemClick={setValue}
      onButtonClick={onConfirmBottomSheetButtonClick}
      buttonTitle={data.buttonTitle}
    />
  );
}
